import React from 'react'
import '../App.css';
import { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import EmptyCart from './EmptyCart';


function CartTotal({Total}){

    const [cupon, setCupon] = useState('');
    const [resultado, setResultado] = useState(0);

    let descuento = 'asminstora10';
    let inventario = 'puertasecreta';

    const hacerDescuento=(n1)=>{

        let resultado = ((n1/100)*10)
        return resultado

    }

    const ejecutarDescuento=()=>{
        if(cupon === descuento){
            Swal.fire({
                icon: 'success',
                title: 'Se aplico correctamente su descuento del 10%',
                showConfirmButton: false,
                timer: 2500
            })
            setResultado(hacerDescuento(Total))
        }if(cupon === inventario){
            window.location.href = '/inventario'
        }
        else{
            Swal.fire({
                icon: 'error',
                title: 'Cupon invalido',
                showConfirmButton: false,
                timer: 3500
            })
        }
    }

    const redireccionar=()=>{
        window.location.href = '/midireccion'
    }

    if(Total === 0){
        return <EmptyCart/>
    }

    return (
        <section className='cart-add'>

            <div className="cupon">
                <h3>Aplicar Cupon</h3>
                <div>
                    <input type="text" placeholder='Introduzca el cupon' onChange={e => setCupon(e.target.value)}/>
                    <button className='normal' onClick={()=> ejecutarDescuento()}>Aplicar</button>
                </div>
            </div>

            <div className="subtotal">
                <h3>Cart Totals</h3>
                <table>
                    <tr>
                        <td>Cart Subtotal</td>
                        <td>RD$ {Total}</td>
                    </tr>
                    <tr>
                        <td>Descuento</td>
                        <td>RD$ {resultado}</td>
                    </tr>
                    <tr>
                        <td>Impuestos</td>
                        <td>Free</td>
                    </tr>
                    <tr>
                        <td><strong>Total</strong></td>
                        <td><strong>RD$ {Total-resultado}</strong></td>
                    </tr>
                </table>
                <button onClick={()=> redireccionar()}>Continuar al Checkout</button>
            </div>
            
        </section>
    )
}

export default CartTotal
